import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { getPositionFromSessionSelector } from '@app/reducers/session';

import WarningIcon from '@app/components/icons/warning';
import { T } from '@app/components/translation';

import style from '../ai-review.module.scss';

type Props = {
  className?: string;
};

export const LanguageWarning = ({ className }: Props) => {
  const currentUser = useSelector(getPositionFromSessionSelector);
  const usingEnglishOrSwedish = currentUser.language === 'en' || currentUser.language === 'sv';

  if (usingEnglishOrSwedish) {
    return null;
  }

  return (
    <div className={clsx(style.LanguageWarning, className)}>
      <WarningIcon
        width="24"
        height="24"
      />
      <T
        featureName="AI Review"
        _str="{featureName} is for the moment only able to review contracts in Swedish or English."
        _comment="Warning label for if the user is using a language not supported by AI review"
      />
    </div>
  );
};
